import React, { useState, useContext, useEffect } from 'react'
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import {
   AppBar,
   Badge,
   Button,
   Box,
   Hidden,
   IconButton,
   Toolbar,
   Menu,
   MenuItem,
   Typography,
   Drawer,
   TextField,
   InputAdornment,
   SvgIcon
} from '@material-ui/core'
import { Search as SearchIcon } from 'react-feather'
import MenuIcon from '@material-ui/icons/Menu'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined'
import InputIcon from '@material-ui/icons/Input'
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import Grid from '@material-ui/core/Grid'
import CancelIcon from '@material-ui/icons/Cancel'

// components
import Logo from './Logo'

// contexts
import { ShoppingCartContext } from '../contexts/ShoppingCart'
import { postPublicAPI, putPublicAPI, getPublicAPI } from '../api'
import { ToastContext } from '../contexts/Toast'
import Chip from '@material-ui/core/Chip'
import notification from '../assets/images/notification.png'
import logo from '../assets/images/logo.jpg'
import socket from '../components/Socket'
import moment from 'moment'
// import { BrowserDatamatrixCodeReader } from '@zxing/library'

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
   const navigate = useNavigate()
   const location = useLocation()
   const { setToasts } = useContext(ToastContext)
   const [anchorQuickDisconnects, setAnchorQuickDisconnects] = useState(null)
   const [openQuickDisconnects, setOpenQuickDisconnects] = useState(false)
   const [anchorQuickDisconnects1, setAnchorQuickDisconnects1] = useState(null)
   const [openQuickDisconnects1, setOpenQuickDisconnects1] = useState(false)
   const [adminnotificationCount, setAdminNotificationCount] = useState()
   const [usernotificationCount, setUserNotificationCount] = useState()
   const [adminNotification, setAdminNotification] = useState([])
   const [userNotification, setUserNotification] = useState([])
   const { innerWidth: windowWidth, innerHeight: windowHeight } = window
   const [NewOrder, setNewOrder] = useState('')

   const {
      searchC,
      setSearchC,
      productsCount,
      setAllProducts,
      setSelectedDashSizesC,
      setSelectedHoseSizesC,
      setSelectedPressuresC,
      setSelectedSizesC,
      setPrice,
      selectedHoseSizesC,
      selectedDashSizesC,
      selectedPressuresC,
      selectedSizesC,
      setOpenFittings,
      setOpenHoses
   } = useContext(ShoppingCartContext)

   try {
      var recentItem = JSON.parse(localStorage.getItem('recent'))
      if (recentItem && recentItem.length > 0)
         localStorage.setItem('recent', JSON.stringify(recentItem))
   } catch {
      var recentItems = []
      localStorage.setItem('recent', JSON.stringify(recentItems))
   }

   const handleQuickDisconnects = event => {
      setOpenQuickDisconnects(true)
      setAnchorQuickDisconnects(event.currentTarget)
   }

   const handleQuickDisconnectsClose = () => setOpenQuickDisconnects(false)

   const handleQuickDisconnects1 = event => {
      setOpenQuickDisconnects1(true)
      setAnchorQuickDisconnects1(event.currentTarget)

      if (localStorage.user_type !== 'customer') setAdminNotificationCount(0)
      if (localStorage.user_type === 'customer') setUserNotificationCount(0)

      const checkNotification = async () => {
         let user = localStorage.user_id
         let notify = await postPublicAPI('/update-notification', { user })
         if (notify?.success) {
            const { adminnotification, usernotification } = notify?.data
            setAdminNotification(adminnotification)
            setUserNotification(usernotification)
         }
      }

      checkNotification()
   }

   const handleQuickDisconnectsClose1 = () => setOpenQuickDisconnects1(false)

   const logout = () => {
      let ip_address = localStorage.ip_address
      localStorage.clear()

      localStorage.setItem('ip_address', ip_address)
      navigate('/login', { replace: true })
   }

   useEffect(() => {
      localStorage.user_type !== 'customer' &&
         NewOrder !== '' &&
         setToasts({
            type: 'success',
            messages: [
               {
                  msg: `New Order from ${NewOrder}`
               }
            ]
         })
   }, [NewOrder])

   const clearAdmin = async notify => {
      let id = notify.notification_id

      const element = document.getElementById('notification-' + id)
      element.classList.add('move-notification')
      element.style.backgroundColor = '#cb6d51'

      let remove = await postPublicAPI('/delete-single-notification-admin', { id })
      if (remove?.success) {
         element.style.backgroundColor = ''
         element.classList.remove('move-notification')
         const { adminnotification } = remove?.data
         setAdminNotification(adminnotification)
      }
   }

   const clearAllAdmin = async () => {
      let remove = await postPublicAPI('/delete-all-notification-admin')
      if (remove?.success) {
         setAdminNotification([])
      }
   }

   const clearCustomer = async notify => {
      let id = notify.notification_id
      let user = localStorage.user_id
      const element = document.getElementById('notification-' + id)
      element.classList.add('move-notification')
      element.style.backgroundColor = '#cb6d51'

      let remove = await postPublicAPI('/delete-single-notification-user', { id, user })
      if (remove?.success) {
         element.style.backgroundColor = ''
         element.classList.remove('move-notification')
         const { usernotification } = remove?.data
         setUserNotification(usernotification)
      }
   }

   const clearAllCustomer = async () => {
      let user = localStorage.user_id
      let remove = await postPublicAPI('/delete-all-notification-user', { user })
      if (remove?.success) {
         setUserNotification([])
      }
   }

   useEffect(() => {
      const getProducts = async () => {
         try {
            let productsData = await getPublicAPI('/get-products')
            if (productsData?.success) {
               setAllProducts(productsData?.data)
            }
         } catch (err) {
            console.log(err.message)
         }
      }
      getProducts()

      const checkStatus = async () => {
         let user = localStorage.user_id
         let status = await postPublicAPI('/check-status', { user })

         if (status?.success) {
            const { userstatus, adminnotification_count, usernotification_count } = status?.data
            localStorage.setItem('user_status', userstatus)
            if (localStorage.user_type === 'customer')
               setUserNotificationCount(usernotification_count)
            if (localStorage.user_type !== 'customer')
               setAdminNotificationCount(adminnotification_count)

            if (userstatus === 'Disabled') {
               localStorage.clear()
               navigate('/login', { replace: true })

               setToasts({
                  type: 'error',
                  messages: [{ msg: 'Account Disabled' }]
               })
            }
         }
      }
      checkStatus()

      const checkNotification = async () => {
         let user = localStorage.user_id
         let notify = await postPublicAPI('/check-notification', { user })
         if (notify?.success) {
            const { adminnotification, usernotification } = notify?.data
            setAdminNotification(adminnotification)
            setUserNotification(usernotification)
         }
      }
      checkNotification()
   }, [navigate, setToasts])

   useEffect(() => {
      if (searchC.length === 0) {
         setSelectedDashSizesC([])
         setSelectedHoseSizesC([])
         setSelectedPressuresC([])
         setSelectedSizesC([])
         setPrice([])
      }
   }, [searchC])

   useEffect(() => {
      if (selectedHoseSizesC.length === 0 && selectedDashSizesC.length === 0) {
         setOpenFittings(false)
      }
      if (selectedPressuresC.length === 0 && selectedSizesC.length === 0) {
         setOpenHoses(false)
      }
   }, [selectedDashSizesC, selectedHoseSizesC, selectedPressuresC, selectedSizesC])

   useEffect(() => {
      const prepareCart = async () => {
         if (localStorage.user_type === 'customer') {
            let data = { user: localStorage.user_email, user2: localStorage.ip_address }
            await putPublicAPI('/update-allcart-product', data)
         }
      }

      prepareCart()
   }, [productsCount])

   let count = parseInt(adminnotificationCount)
   socket.on('notifyAdmin', msg => {
      count++
      setAdminNotificationCount(count)
      let data = JSON.parse(msg)
      let user = data.user
      setNewOrder(user)
      const checkNotification = async () => {
         let user = localStorage.user_id
         let notify = await postPublicAPI('/check-notification', { user })
         if (notify?.success) {
            const { adminnotification, usernotification } = notify?.data
            setAdminNotification(adminnotification)
            setUserNotification(usernotification)
         }
      }
      checkNotification()
   })

   let userCount = parseInt(usernotificationCount)
   socket.on('notifyUser', msg => {
      userCount++
      setUserNotificationCount(userCount)
      const checkNotification = async () => {
         let user = localStorage.user_id
         let notify = await postPublicAPI('/check-notification', { user })
         if (notify?.success) {
            const { adminnotification, usernotification } = notify?.data
            setAdminNotification(adminnotification)
            setUserNotification(usernotification)
         }
      }
      checkNotification()
   })

   return (
      <AppBar elevation={0} {...rest}>
         <Toolbar
            sx={
               windowWidth > 425
                  ? '{{}}'
                  : `{{ height: 128,paddingTop:2,marginTop:1,alignItems: 'flex-start', }}`
            }
         >
            {!localStorage.auth_token && (
               <RouterLink to='/'>
                  <Logo />
               </RouterLink>
            )}
            {localStorage.auth_token && (
               <RouterLink to='/app/dashboard'>
                  <Logo />
               </RouterLink>
            )}
            {windowWidth > 425 && (
               <Box sx={{ marginLeft: 15, minWidth: '25vw' }}>
                  <TextField
                     id='search'
                     fullWidth
                     size='small'
                     sx={{
                        backgroundColor: 'white',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 40
                     }}
                     InputProps={{
                        startAdornment: (
                           <InputAdornment position='start'>
                              <SvgIcon fontSize='small' color='action'>
                                 <SearchIcon />
                              </SvgIcon>
                           </InputAdornment>
                        )
                     }}
                     placeholder={
                        location.pathname === '/app/fittings'
                           ? 'Search fittings'
                           : location.pathname === '/app/hoses'
                           ? 'Search hoses'
                           : 'Search products'
                     }
                     value={searchC}
                     onChange={e => {
                        setSearchC(e.target.value)
                     }}
                     variant='outlined'
                  />
               </Box>
            )}
            <Box
               sx={{
                  display: 'flex',
                  flexGrow: 1,
                  justifyContent: 'flex-end'
               }}
            >
               {localStorage.user_type === 'customer' && (
                  <IconButton onClick={() => navigate('/app/cart')} color='inherit'>
                     <Badge badgeContent={productsCount} color='secondary'>
                        {location.pathname === '/app/cart' ? (
                           <ShoppingCartIcon />
                        ) : (
                           <ShoppingCartOutlinedIcon />
                        )}
                     </Badge>
                  </IconButton>
               )}
               <IconButton
                  color='inherit'
                  onClick={handleQuickDisconnects1}
                  aria-owns={openQuickDisconnects1 ? 'quick-disconnects1' : null}
                  aria-haspopup='true'
               >
                  {localStorage.user_type === 'customer' && (
                     <Badge badgeContent={usernotificationCount} color='secondary'>
                        <NotificationsIcon />
                     </Badge>
                  )}
                  {localStorage.user_type !== 'customer' && (
                     <Badge badgeContent={adminnotificationCount} color='secondary'>
                        <NotificationsIcon />
                     </Badge>
                  )}
               </IconButton>
               {windowWidth > 425 && (
                  <Menu
                     id='quick-disconnects1'
                     className='nav-menu'
                     anchorEl={anchorQuickDisconnects1}
                     open={openQuickDisconnects1}
                     onClose={handleQuickDisconnectsClose1}
                     PaperProps={{
                        style: {
                           position: 'absolute',
                           marginLeft: 12,
                           width: 380,
                           maxHeight: 200
                        }
                     }}
                  >
                     {localStorage.user_type !== 'customer' && (
                        <>
                           {adminNotification.length > 0 && (
                              <>
                                 {adminNotification.map((notify, index) => (
                                    <>
                                       <Grid container spacing={1}>
                                          <Grid item xs={10.7}>
                                             <MenuItem
                                                id={`notification-${notify.notification_id}`}
                                                style={{ backgroundColor: '', transform: '' }}
                                                key={index}
                                                onClick={e => {
                                                   navigate(
                                                      '/app/order-detail/' + notify.order_oNum,
                                                      {}
                                                   )
                                                   handleQuickDisconnectsClose1()
                                                }}
                                             >
                                                <Grid container spacing={3}>
                                                   <Grid item xs={3}>
                                                      {notify.products.length > 1 && (
                                                         <Box sx={{ marginLeft: 0 }}>
                                                            <Badge
                                                               badgeContent={notify.products.length}
                                                               color='primary'
                                                               anchorOrigin={{
                                                                  vertical: 'top',
                                                                  horizontal: 'left'
                                                               }}
                                                            >
                                                               <img
                                                                  className='notification-product-images'
                                                                  src={
                                                                     notify.products[0].pictures
                                                                        .length > 0
                                                                        ? notify.products[0]
                                                                             .pictures[0]
                                                                        : logo
                                                                  }
                                                                  alt={notify.products[0].rhpn}
                                                               />{' '}
                                                            </Badge>
                                                         </Box>
                                                      )}
                                                      {notify.products.length === 1 && (
                                                         <Box sx={{ marginLeft: 0 }}>
                                                            <img
                                                               className='notification-product-images'
                                                               src={
                                                                  notify.products[0].pictures
                                                                     .length > 0
                                                                     ? notify.products[0]
                                                                          .pictures[0]
                                                                     : logo
                                                               }
                                                               alt={notify.products[0].rhpn}
                                                            />{' '}
                                                         </Box>
                                                      )}
                                                      
                                                   </Grid>
                                                   <Grid item xs={3}>
                                                      {notify.products.length > 1 && (
                                                         <Typography>
                                                            {notify.products[0].rhpn}..
                                                            <Chip
                                                               label='New Order'
                                                               variant='outlined'
                                                               sx={{
                                                                  color: '#4ab048',
                                                                  marginLeft: 2
                                                               }}
                                                            />
                                                         </Typography>
                                                      )}
                                                      {notify.products.length === 1 && (
                                                         <Typography>
                                                            {notify.products[0].rhpn}
                                                            <Chip
                                                               label='New Order'
                                                               variant='outlined'
                                                               sx={{
                                                                  color: '#4ab048',
                                                                  marginLeft: 2
                                                               }}
                                                            />
                                                         </Typography>
                                                      )}
                                                      <Typography>{notify.customer}</Typography>
                                                      <Typography>
                                                         {moment
                                                            .utc(notify.datetime)
                                                            .local()
                                                            .format('hh:mm A, DD MMM')}
                                                      </Typography>
                                                   </Grid>
                                                </Grid>
                                             </MenuItem>
                                          </Grid>
                                          <Grid item xs={1}>
                                             <IconButton
                                                onClick={() => clearAdmin(notify)}
                                                size='small'
                                                className='menu-cancel'
                                                sx={{ opacity: 0.4 }}
                                             >
                                                <CancelIcon />
                                             </IconButton>
                                          </Grid>
                                       </Grid>
                                    </>
                                 ))}
                                 <Button onClick={() => clearAllAdmin()} fullWidth sx={{}}>
                                    Clear All
                                 </Button>
                              </>
                           )}
                           {adminNotification.length === 0 && (
                              <>
                                 <MenuItem sx={{ justifyContent: 'center' }}>
                                    <Typography>You have no new notifications</Typography>
                                 </MenuItem>
                                 <MenuItem sx={{ justifyContent: 'center' }}>
                                    <Box>
                                       <img
                                          alt='notification'
                                          className='notification-bell-image'
                                          src={notification}
                                          style={{ opacity: 0.2 }}
                                       />
                                    </Box>
                                 </MenuItem>
                              </>
                           )}
                        </>
                     )}
                     {localStorage.user_type === 'customer' && (
                        <>
                           {userNotification.length > 0 && (
                              <>
                                 {userNotification.map((notify, index) => (
                                    <>
                                       <Grid container spacing={1}>
                                          <Grid item xs={10.8}>
                                             <MenuItem
                                                id={`notification-${notify.notification_id}`}
                                                style={{ backgroundColor: '' }}
                                                key={index}
                                                onClick={e => {
                                                   navigate(
                                                      '/app/order-detail/' + notify.order_oNum
                                                   )
                                                   handleQuickDisconnectsClose1()
                                                }}
                                             >
                                                <Grid container spacing={3}>
                                                   <Grid item xs={3} sx={{ ml: 0 }}>
                                                      <Box sx={{ marginLeft: 0 }}>
                                                         <img
                                                            className='notification-product-images'
                                                            src={
                                                               notify.pictures.length > 0
                                                                  ? notify.pictures[0]
                                                                  : logo
                                                            }
                                                            alt={notify.rhpn}
                                                         />
                                                      </Box>
                                                   </Grid>
                                                   <Grid item xs={3}>
                                                      <Typography>
                                                         Product {notify.rhpn}
                                                         <Chip
                                                            label='Shipped'
                                                            size='small'
                                                            variant='outlined'
                                                            sx={{ color: '#4ab048', marginLeft: 1 }}
                                                         />
                                                      </Typography>
                                                      <Typography>
                                                         {moment
                                                            .utc(notify.datetime)
                                                            .local()
                                                            .format('hh:mm A, DD MMM')}
                                                      </Typography>
                                                   </Grid>
                                                </Grid>
                                             </MenuItem>
                                          </Grid>
                                          <Grid item xs={1}>
                                             <IconButton
                                                onClick={() => clearCustomer(notify)}
                                                size='small'
                                                className='menu-cancel'
                                                sx={{ opacity: 0.3 }}
                                             >
                                                <CancelIcon />
                                             </IconButton>
                                          </Grid>
                                       </Grid>
                                    </>
                                 ))}
                                 <Button onClick={() => clearAllCustomer()} fullWidth sx={{}}>
                                    Clear All
                                 </Button>
                              </>
                           )}
                           {userNotification.length === 0 && (
                              <>
                                 <MenuItem sx={{ justifyContent: 'center' }}>
                                    <Typography>You have no new notifications</Typography>
                                 </MenuItem>
                                 <MenuItem sx={{ justifyContent: 'center' }}>
                                    <Box>
                                       <img
                                          alt={'notification'}
                                          className='notification-bell-image'
                                          src={notification}
                                          style={{ opacity: 0.2 }}
                                       />
                                    </Box>
                                 </MenuItem>
                              </>
                           )}
                        </>
                     )}
                  </Menu>
               )}

               {windowWidth <= 425 && (
                  <>
                     <Drawer
                        anchor='top'
                        open={openQuickDisconnects1}
                        onClose={handleQuickDisconnectsClose1}
                        variant='temporary'
                        PaperProps={{
                           sx: {
                              position: 'relative',
                              width: windowWidth,
                              top: 54,
                              maxHeight: windowHeight * 0.4
                           }
                        }}
                     >
                        {localStorage.user_type !== 'customer' && (
                           <>
                              {adminNotification.length > 0 && (
                                 <>
                                    <Box sx={{ mt: 2 }}>
                                       {adminNotification.map((notify, index) => (
                                          <>
                                             <Grid container spacing={1}>
                                                <Grid item xs={10.7}>
                                                   <MenuItem
                                                      id={`notification-${notify.notification_id}`}
                                                      style={{ backgroundColor: '' }}
                                                      key={index}
                                                      onClick={e => {
                                                         navigate(
                                                            '/app/order-detail/' +
                                                               notify.order_oNum,
                                                            {}
                                                         )
                                                         handleQuickDisconnectsClose1()
                                                      }}
                                                   >
                                                      <Grid container spacing={3}>
                                                         <Grid item xs={3}>
                                                            {notify.products.length > 1 && (
                                                               <Box sx={{ marginLeft: 0 }}>
                                                                  <Badge
                                                                     badgeContent={
                                                                        notify.products.length
                                                                     }
                                                                     color='primary'
                                                                     anchorOrigin={{
                                                                        vertical: 'top',
                                                                        horizontal: 'left'
                                                                     }}
                                                                  >
                                                                     <img
                                                                        className='notification-product-images'
                                                                        src={
                                                                           notify.products[0]
                                                                              .pictures.length > 0
                                                                              ? notify.products[0]
                                                                                   .pictures[0]
                                                                              : logo
                                                                        }
                                                                        alt={
                                                                           notify.products[0].rhpn
                                                                        }
                                                                     />{' '}
                                                                  </Badge>
                                                               </Box>
                                                            )}
                                                            {notify.products.length === 1 && (
                                                               <Box sx={{ marginLeft: 0 }}>
                                                                  <img
                                                                     className='notification-product-images'
                                                                     src={
                                                                        notify.products[0].pictures
                                                                           .length > 0
                                                                           ? notify.products[0]
                                                                                .pictures[0]
                                                                           : logo
                                                                     }
                                                                     alt={notify.products[0].rhpn}
                                                                  />{' '}
                                                               </Box>
                                                            )}
                                                         </Grid>

                                                         <Grid item xs={3}>
                                                            {notify.products.length > 1 && (
                                                               <Typography sx={{ fontSize: 14 }}>
                                                                  {notify.products[0].rhpn}..
                                                                  <Chip
                                                                     label='New Order'
                                                                     size='small'
                                                                     variant='outlined'
                                                                     sx={{
                                                                        color: '#4ab048',
                                                                        marginLeft: 2
                                                                     }}
                                                                  />
                                                               </Typography>
                                                            )}
                                                            {notify.products.length === 1 && (
                                                               <Typography sx={{ fontSize: 14 }}>
                                                                  {notify.products[0].rhpn}
                                                                  <Chip
                                                                     label='New Order'
                                                                     size='small'
                                                                     variant='outlined'
                                                                     sx={{
                                                                        color: '#4ab048',
                                                                        marginLeft: 2
                                                                     }}
                                                                  />
                                                               </Typography>
                                                            )}
                                                            <Typography sx={{ fontSize: 14 }}>
                                                               {notify.customer}
                                                            </Typography>
                                                            <Typography sx={{ fontSize: 14 }}>
                                                               {moment
                                                                  .utc(notify.datetime)
                                                                  .local()
                                                                  .format('hh:mm A, DD MMM')}
                                                            </Typography>
                                                         </Grid>
                                                      </Grid>
                                                   </MenuItem>
                                                </Grid>
                                                <Grid item xs={1}>
                                                   <IconButton
                                                      onClick={() => clearAdmin(notify)}
                                                      size='small'
                                                      className='menu-cancel'
                                                      sx={{ opacity: 0.4 }}
                                                   >
                                                      <CancelIcon />
                                                   </IconButton>
                                                </Grid>
                                             </Grid>
                                          </>
                                       ))}
                                       <Button onClick={() => clearAllAdmin()} fullWidth>
                                          Clear All
                                       </Button>
                                    </Box>
                                 </>
                              )}
                              {adminNotification.length === 0 && (
                                 <>
                                    <MenuItem sx={{ justifyContent: 'center' }}>
                                       <Typography>You have no new notifications</Typography>
                                    </MenuItem>
                                    <MenuItem sx={{ justifyContent: 'center' }}>
                                       <Box>
                                          <img
                                             alt='notification'
                                             className='notification-bell-image'
                                             src={notification}
                                             style={{ opacity: 0.2 }}
                                          />
                                       </Box>
                                    </MenuItem>
                                 </>
                              )}
                           </>
                        )}

                        {localStorage.user_type === 'customer' && (
                           <>
                              {userNotification.length > 0 && (
                                 <>
                                    <Box sx={{ mt: 2 }}>
                                       {userNotification.map((notify, index) => (
                                          <>
                                             <Grid container spacing={1}>
                                                <Grid item xs={10.8}>
                                                   <MenuItem
                                                      id={`notification-${notify.notification_id}`}
                                                      style={{ backgroundColor: '' }}
                                                      key={index}
                                                      onClick={e => {
                                                         navigate(
                                                            '/app/order-detail/' + notify.order_oNum
                                                         )
                                                         handleQuickDisconnectsClose1()
                                                      }}
                                                   >
                                                      <Grid container spacing={3}>
                                                         <Grid item xs={3} sx={{ ml: 0 }}>
                                                            <Box sx={{ marginLeft: 0 }}>
                                                               <img
                                                                  className='notification-product-images'
                                                                  src={
                                                                     notify.pictures.length > 0
                                                                        ? notify.pictures[0]
                                                                        : logo
                                                                  }
                                                                  alt={notify.rhpn}
                                                               />{' '}
                                                            </Box>
                                                         </Grid>

                                                         <Grid item xs={3}>
                                                            <Typography sx={{ fontSize: 14 }}>
                                                               Product {notify.rhpn}
                                                               <Chip
                                                                  label='Shipped'
                                                                  size='small'
                                                                  variant='outlined'
                                                                  sx={{
                                                                     color: '#4ab048',
                                                                     marginLeft: 1
                                                                  }}
                                                               />
                                                            </Typography>
                                                            <Typography sx={{ fontSize: 14 }}>
                                                               {moment
                                                                  .utc(notify.datetime)
                                                                  .local()
                                                                  .format('hh:mm A, DD MMM')}
                                                            </Typography>
                                                         </Grid>
                                                      </Grid>
                                                   </MenuItem>
                                                </Grid>
                                                <Grid item xs={1}>
                                                   <IconButton
                                                      onClick={() => clearCustomer(notify)}
                                                      size='small'
                                                      className='menu-cancel'
                                                      sx={{ opacity: 0.3 }}
                                                   >
                                                      <CancelIcon />
                                                   </IconButton>
                                                </Grid>
                                             </Grid>
                                          </>
                                       ))}
                                       <Button onClick={() => clearAllCustomer()} fullWidth sx={{}}>
                                          Clear All
                                       </Button>
                                    </Box>
                                 </>
                              )}
                              {userNotification.length === 0 && (
                                 <>
                                    <MenuItem sx={{ justifyContent: 'center' }}>
                                       <Typography>You have no new notifications</Typography>
                                    </MenuItem>
                                    <MenuItem sx={{ justifyContent: 'center' }}>
                                       <Box>
                                          <img
                                             alt={'notification'}
                                             className='notification-bell-image'
                                             src={notification}
                                             style={{ opacity: 0.2 }}
                                          />
                                       </Box>
                                    </MenuItem>
                                 </>
                              )}
                           </>
                        )}
                     </Drawer>
                  </>
               )}
            </Box>

            <Hidden lgDown>
               <Button
                  endIcon={<ArrowDropDownIcon />}
                  style={{ color: '#fff' }}
                  aria-owns={openQuickDisconnects ? 'quick-disconnects' : null}
                  aria-haspopup='true'
                  onClick={handleQuickDisconnects}
               >
                  My Account
               </Button>
               <Menu
                  id='quick-disconnects'
                  className='nav-menu'
                  anchorEl={anchorQuickDisconnects}
                  open={openQuickDisconnects}
                  onClose={handleQuickDisconnectsClose}
                  PaperProps={{
                     style: {
                        width: 200
                     }
                  }}
               >
                  <MenuItem onClick={() => navigate('/app/account')}>
                     <PersonOutlineIcon className='nav-dropdown' />
                     Profile
                  </MenuItem>
                  <MenuItem onClick={logout}>
                     <ExitToAppIcon className='nav-dropdown' />
                     Logout
                  </MenuItem>
               </Menu>

               <IconButton onClick={logout} color='inherit'>
                  <InputIcon />
               </IconButton>
            </Hidden>
            <Hidden lgUp>
               <IconButton color='inherit' onClick={onMobileNavOpen}>
                  <MenuIcon />
               </IconButton>
            </Hidden>
         </Toolbar>
         {windowWidth <= 425 && (
            <Toolbar fullWidth sx={{ flexGrow: 1 }}>
               <Box>
                  <TextField
                     id='search'
                     fullWidth
                     size='small'
                     sx={{
                        backgroundColor: 'white',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 40,
                        width: windowWidth * 0.9
                     }}
                     InputProps={{
                        startAdornment: (
                           <InputAdornment position='start'>
                              <SvgIcon fontSize='small' color='action'>
                                 <SearchIcon />
                              </SvgIcon>
                           </InputAdornment>
                        )
                     }}
                     placeholder={
                        location.pathname === '/app/fittings'
                           ? 'Search fittings'
                           : location.pathname === '/app/hoses'
                           ? 'Search hoses'
                           : 'Search products'
                     }
                     value={searchC}
                     onChange={e => {
                        setSearchC(e.target.value)
                     }}
                     variant='outlined'
                  />
               </Box>
            </Toolbar>
         )}
      </AppBar>
   )
}

DashboardNavbar.propTypes = {
   onMobileNavOpen: PropTypes.func
}

export default DashboardNavbar
